// Pending-order banner keys written on confirmation / checkout.
// Cleared when the order is collected, cancelled, or no longer fetchable
// (e.g. past the daily period → API 404).

const KEYS = ['active_order_group', 'active_order_group_owner', 'active_order_path'];

export function clearActiveOrder() {
  for (const key of KEYS) {
    localStorage.removeItem(key);
  }
}
